import gsap from "../../build/node_modules/gsap";
import { ScrollTrigger } from "../../build/node_modules/gsap/ScrollTrigger";
import { CustomEase } from "../_libs/CustomEase.js";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

window.website = {
  html: document.querySelector("html"),
  body: document.querySelector("body"),
  currentY: 0,
  velocity: 0,
  winW: window.innerWidth,
  winH: window.innerHeight,
  isDesktop: window.innerWidth >= 1025 ? true : false,
  isTablet: navigator.userAgent.indexOf("iPad") > -1 || (navigator.userAgent.indexOf("Macintosh") > -1 && "ontouchend" in document) || navigator.userAgent.indexOf("Android") > -1,
  debug: location.hash === "#debug" ? true : false,
  page: null,
};

export default class {
  constructor() {
    this.website = window.website;
  }

  getNameSpace(tgt) {
    return tgt.getAttribute("data-barba-namespace");
  }

  getPage() {
    if (document.getElementById("page-top")) {
      window.website.page = "top";
    } else if (document.getElementById("page-business-partner")) {
      window.website.page = "business-partner";
    } else if (document.getElementById("page-membership")) {
      window.website.page = "membership";
    } else if (document.getElementById("page-about")) {
      window.website.page = "about";
    } else if (document.getElementById("page-stay")) {
      window.website.page = "stay";
    }

    console.log(window.website.page);

    return null;
  }

  getWinSize() {
    return { w: window.innerWidth, h: window.innerHeight };
  }

  append(t) {
    let target = $(t);
    $(t).remove();
    $("body").append(target);
  }
}

export { gsap };
export { CustomEase };
export { ScrollTrigger };
